<div class="modal-content" dir="ltr">
    <div class="modal-header">
        <h4 class="heading-special-3" translate="cart.locale.switcher.change"></h4>
        <button type="button" class="close fa-solid fa-xmark" [attr.aria-label]="'cart.button.close'| translate" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
        <div class="search-bar">
            <input type="search" [(ngModel)]="search" [attr.aria-label]="'cart.locale.switcher.search'| translate" placeholder="{{'cart.locale.switcher.search' | translate}}" class="form-control">
        </div>
        <locale-list [search]="search" [localeType]="localeType" (localeEvent)="onLocaleChange($event)"></locale-list>
    </div>
</div>
